import { jwtDecode, JwtPayload } from 'jwt-decode';
import camelcaseKeys from 'camelcase-keys';

import { UserDetail } from 'types/user';

type TokenType = {
  userId: string;
  nameTh: string;
  nameEn: string;
  role: string;
  exp: number;
};

export function isTokenExpired(decodedToken: TokenType | null): boolean {
  if (!decodedToken || decodedToken.exp === undefined) {
    return true;
  }

  const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
  return decodedToken.exp < currentTime;
}

export function decodeToken(token?: string | null): TokenType {
  if (!token) {
    return {} as TokenType;
  }

  try {
    const decodedToken = jwtDecode(token);
    const camelCasedToken = camelcaseKeys(
      decodedToken as Record<string, unknown>,
    );
    return camelCasedToken as TokenType;
  } catch (error) {
    // Failed to decode token
    console.error('Failed to decode token:', error);
    return {} as TokenType;
  }
}

export function getUserDetail(): UserDetail {
  const token = localStorage.getItem('token');
  const decodedToken = decodeToken(token);
  const userDetail = {
    userId: decodedToken.userId,
    nameTh: decodedToken.nameTh,
    nameEn: decodedToken.nameEn,
    role: decodedToken.role,
  };
  return userDetail;
}
